import { callApi } from '../../libs'

const createBooking = async (data) => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/bookings`
        const method = 'post'
        const body = data
        try {
            const response = await callApi(method, url, body, null)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default createBooking